<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>BL Release Pending List</b-navbar-brand>

          <div>
            <h5 class="text-muted justify-content-center">
              <small>{{ totalRows }} Entries</small>
            </h5>
          </div>
        </b-navbar>
        <div>
          <b-collapse class="mt-2" v-model="visible" id="collapse-2">
            <b-card>
              <b-row class="mt-2">
                <b-col class="col-md-3">
                  <label for="blType">Client</label>
                  <model-list-select
                    :list="$store.getters['common/getAllClientList']"
                    id="clientNamenew"
                    v-model="Filter.clientIdFilter"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select Client Name"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col class="col-md-3">
                  <label>Date :</label>
                  <date-range-picker
                    :opens="openLeft"
                    :always-show-calendars="showCal"
                    v-model="dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    @update="SearchFilter"
                  ></date-range-picker>
                </b-col>
                <b-col class="col-md-3">
                  <label>POR</label>
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    :list="$store.getters['common/getAllPORList']"
                    v-model="Filter.PORfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Place of Receipt"
                    @update="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col class="col-md-3">
                  <label>POD</label>
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    :list="$store.getters['common/getAllPODList']"
                    v-model="Filter.PODfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Port of Discharge"
                    @update="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col class="col-md-3">
                  <label>Shipping Line</label>
                  <model-list-select
                    :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.shippingLineFilter"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                    @update="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col class="col-md-3">
                  <label>POL</label>
                  <model-list-select
                    @input="getLocationList($event, 'All', 'PortLoadList')"
                    @searchchange="getLocationList($event, 'All', 'PortLoadList')"
                    :list="$store.getters['common/getAllPOLList']"
                    v-model="Filter.LPlocationId"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POL"
                    @update="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col>
                  <label>FPOD</label>
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    :list="$store.getters['common/getAllLocationDetailsFinalList']"
                    v-model="Filter.finalPlaceLocationId"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select FPOD"
                    @update="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col class="col-md-3">
                  <label>Branch</label>

                  <multi-select
                    :options="$store.getters['common/getAllBranchList']"
                    :selected-options="branch_items"
                    v-model="Filter.branchfilter"
                    placeholder="Select Branch"
                    :multiple="true"
                    id="Client"
                    @select="SelectMultiBranch"
                    @input="SearchFilter"
                  ></multi-select>
                </b-col>
                <b-col class="col-md-3">
                  <label>Agent Name</label>
                  <model-list-select
                    :list="$store.getters['common/getAllAgentColoaderList']"
                    id="ToFilter"
                    v-model="Filter.ToFilter"
                    option-value="agentName"
                    option-text="agentName"
                    placeholder="All"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col class="col-md-3">
                  <label>Consignee</label>
                  <model-list-select
                    :list="$store.getters['common/getAllConsigneeList']"
                    id="Consignee"
                    v-model="Filter.Consignee"
                    option-value="consignee"
                    option-text="consignee"
                    placeholder="Select Consignee"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col class="col-md-3">
                  <label>Consignor</label>
                  <model-list-select
                    :list="$store.getters['common/getAllConsignorList']"
                    id="Consignor"
                    v-model="Filter.Consignor"
                    option-value="consignorName"
                    option-text="consignorName"
                    placeholder="Select Consignor"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Assignment No.</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    placeholder="Assignment No."
                    id="assignmentNo"
                    name="assignmentNo"
                    v-model="Filter.assignmentNo"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Payment Status</label>
                  <model-list-select
                    :list="PaymentStatusList"
                    id="paymentStatus"
                    v-model="Filter.paymentStatus"
                    option-value="int"
                    option-text="inv"
                    placeholder="Select Payment Status"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    placeholder="Common Filter"
                    id="commonFilter"
                    name="commonFilter"
                    v-model="Filter.commonFilter"
                  ></b-form-input>
                </b-col>
              </b-row>
              <div class="mt-3 row justify-content-center">
                <b-button size="sm" @click="SearchFilter" variant="outline-primary"
                  >Search
                </b-button>
                <b-button
                  size="sm"
                  class="ml-2"
                  @click="filterClear"
                  variant="outline-info"
                  >clear</b-button
                >
                <b-button
                  :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
                  class="pull-right ml-1"
                  v-if="All_BL_List_data.length > 0"
                  @click="getReports('getBLSubsList')"
                  size="sm"
                  variant="warning"
                  >{{ ExcelBtnName }}
                  <b-spinner
                    v-if="ExcelBtnName != 'Export As Excel'"
                    small
                    label="Small Spinner"
                  ></b-spinner
                ></b-button>
              </div>
            </b-card>
          </b-collapse>
        </div>
        <div class="table-responsive tableMain mt-2">
          <b-table
            reg="BLListRef"
            :items="All_BL_List_data"
            :fields="fields"
            responsive
            primary-key="ffExportFclId"
            show-empty
            stacked="md"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
            class="position-relative"
          >
            <template slot="ffExportFclId" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="SysSOB" slot-scope="row1">
              <b>{{ "Booking SOB : " + row1.item.SysSOB }}</b
              ><br />
              <b>{{ "P44 SOB : " + row1.item.sob_date_detected }}</b
              ><br />
              <b>{{ "Payment Status : " }}</b
              ><b-button
                style="font-size: 0.675rem"
                size="sm"
                @click="
                  row1.item.Payment_Status == 'Pending' ||
                  row1.item.Payment_Status == '' ||
                  row1.item.Payment_Status == null ||
                  row1.item.Payment_Status == undefined
                    ? PaymentSline(row1.item)
                    : ''
                "
                :variant="
                  row1.item.Payment_Status == 'Pending' ||
                  row1.item.Payment_Status == '' ||
                  row1.item.Payment_Status == null ||
                  row1.item.Payment_Status == undefined
                    ? 'outline-danger'
                    : 'outline-info'
                "
                class="pull-right"
                >{{
                  row1.item.Payment_Status == "Pending" ||
                  row1.item.Payment_Status == "" ||
                  row1.item.Payment_Status == null ||
                  row1.item.Payment_Status == undefined
                    ? "Pending"
                    : row1.item.Payment_Status
                }}</b-button
              >
            </template>
            <template slot="BLCond" slot-scope="row12">
              <b class="text-danger">{{ "BL Type : " + row12.item.blType }}</b
              ><br />
              <b class="text-danger" @click="viewEditBLNonUs(row12.item)">{{
                "BL No : " + row12.item.BlNumber
              }}</b
              >
              <br />
              <b-button
                :variant="
                  row12.item.uploadBL == null ||
                  row12.item.uploadBL == undefined ||
                  row12.item.uploadBL == ''
                    ? 'outline-warning'
                    : 'outline-info'
                "
                size="sm"
                style="font-size: 0.675rem"
                class="text-danger"
                @click="
                  row12.item.uploadBL == null ||
                  row12.item.uploadBL == undefined ||
                  row12.item.uploadBL == ''
                    ? viewEditBLNonUs(row12.item)
                    : viewEditBLNonUs(row12.item)
                "
                >{{
                  row12.item.uploadBL == null ||
                  row12.item.uploadBL == undefined ||
                  row12.item.uploadBL == ""
                    ? "Pending"
                    : row12.item.BlNumber
                }}</b-button
              ><br />
              <b-button
                :disabled="
                  row12.item.uploadBL == null ||
                  row12.item.uploadBL == undefined ||
                  row12.item.uploadBL == ''
                    ? true
                    : false
                "
                :variant="
                  row12.item.uploadBL == null ||
                  row12.item.uploadBL == undefined ||
                  row12.item.uploadBL == ''
                    ? 'outline-warning'
                    : 'outline-info'
                "
                size="sm"
                style="font-size: 0.675rem"
                class="text-danger"
                @click="
                  row12.item.uploadBL == null ||
                  row12.item.uploadBL == undefined ||
                  row12.item.uploadBL == ''
                    ? ''
                    : PrintNote(row12.item.uploadBL, row12.item.assignment_number)
                "
                >{{
                  row12.item.uploadBL == null ||
                  row12.item.uploadBL == undefined ||
                  row12.item.uploadBL == ""
                    ? "NA"
                    : "PDF"
                }}</b-button
              ><br />
              
              <b class="text-danger" @click="viewEditBLNonUs(row12.item)">{{
                "MBL No : " + row12.item.MBLNO
              }}</b><br />
              <b-button
                :variant="
                  row12.item.MBL_Doc == null ||
                  row12.item.MBL_Doc == undefined ||
                  row12.item.MBL_Doc == ''
                    ? 'outline-warning'
                    : 'outline-info'
                "
                size="sm"
                style="font-size: 0.675rem"
                class="text-danger"
                @click="
                  row12.item.MBL_Doc == null ||
                  row12.item.MBL_Doc == undefined ||
                  row12.item.MBL_Doc == ''
                    ? viewEditBLNonUs(row12.item)
                    : viewEditBLNonUs(row12.item)
                "
                >{{
                  row12.item.MBL_Doc == null ||
                  row12.item.MBL_Doc == undefined ||
                  row12.item.MBL_Doc == ""
                    ? "Pending"
                    : row12.item.MBLNO
                }}</b-button
              ><br />
              <b-button
                :disabled="
                  row12.item.MBL_Doc == null ||
                  row12.item.MBL_Doc == undefined ||
                  row12.item.MBL_Doc == ''
                    ? true
                    : false
                "
                :variant="
                  row12.item.MBL_Doc == null ||
                  row12.item.MBL_Doc == undefined ||
                  row12.item.MBL_Doc == ''
                    ? 'outline-warning'
                    : 'outline-info'
                "
                size="sm"
                style="font-size: 0.675rem"
                class="text-danger"
                @click="
                  row12.item.MBL_Doc == null ||
                  row12.item.MBL_Doc == undefined ||
                  row12.item.MBL_Doc == ''
                    ? ''
                    : PrintNote(row12.item.MBL_Doc, row12.item.assignment_number)
                "
                >{{
                  row12.item.MBL_Doc == null ||
                  row12.item.MBL_Doc == undefined ||
                  row12.item.MBL_Doc == ""
                    ? "NA"
                    : "PDF"
                }}</b-button
              ><br />
              <span>{{ row12.item.blDate | moment }}</span> <br /><br />
              <span
                >BL Stage: <b>{{ row12.item.blStage }}</b></span
              >
            </template>

            <template slot="AssignementDetails" slot-scope="row21">
              <b>Assignement Number : {{ row21.item.assignment_number }}</b>
              <br />
              <b>Assignement Date : {{ row21.item.assigement_date | moment }}</b>
              <br />
              <b>Raised From : {{ row21.item.RasiedFrom }}</b>
              <br />
              <b>Rasied By : {{ row21.item.username }}</b>
            </template>

            <template slot="POR" slot-scope="row3">
              <span><b>POD</b> : {{ row3.item.POD }}</span>
              <br />
              <span><b>POL</b> : {{ row3.item.POL }}</span>
              <br />
              <span><b>POR</b> : {{ row3.item.POR }}</span>
              <br />
              <span><b>FPOD</b> : {{ row3.item.FPOD }}</span>
              <br />
            </template>
            <template slot="clientName" slot-scope="row4">
              <span
                >Client Name : <b>{{ row4.item.clientName }}</b></span
              >
              <br />
              <span
                >Shipper Name : <b>{{ row4.item.ShippingLine }}</b></span
              >
            </template>
            <template slot="ConsoleBooking" slot-scope="row5">
              <span
                v-if="
                  row5.item.sob_date_detected != '' && row5.item.sob_date_detected != null
                "
                ><b :style="'color:black'"
                  ><b>SOB :</b> {{ row5.item.sob_date_detected }}</b
                >
                <b-badge variant="danger"><b>SAILED</b></b-badge
                ><br
              /></span>
            </template>
            <template slot="SubscriptionID" slot-scope="row6">
              <b
                @click="
                  row6.item.SubscriptionID &&
                  row6.item.subscription_status_detials_status == 1
                    ? trackingRed(row6.item.SubscriptionID)
                    : ''
                "
                ><b-badge variant="danger">{{ row6.item.SubscriptionID }}</b-badge
                ><br
              /></b>
              <span>{{ row6.item.subscription_status_detials }}<br /></span>
              <span>{{ row6.item.Subscription_CreateDate }}</span>
            </template>
            <template slot="vgmSubmissionDate" slot-scope="row7">
              <span v-if="row7.item.vgmSubmissionDate"
                ><b>VGM :</b> {{ row7.item.vgmSubmissionDate }}<br
              /></span>
              <span v-if="row7.item.siSubmissionDate"
                ><b>SI :</b> {{ row7.item.siSubmissionDate }}</span
              >
            </template>
            <template slot="Payment_Status" slot-scope="row8">
              <span>{{ row8.item.Payment_Status }}</span>
            </template>
            <template slot="subStatus" slot-scope="row8">
              <span>{{ row8.item.subStatus }}</span>
            </template>
            <template slot="vessel_voyage" slot-scope="row9">
              <span>{{
                row9.item.vessel_voyage
                  ? row9.item.vessel_voyage
                  : row9.item.Sysvessel_voyage
              }}</span
              ><br />
              <span>Booking No : {{ row9.item.CBbooking_no }}</span>
            </template>
          </b-table>
        </div>
        <div>
          <b-pagination
            aria-controlles="BLLIst"
            limit="10"
            align="center"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
            first-number
            last-number
          ></b-pagination>

          <!-- @change="onPageChange($event)" -->
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import CommonService from "../../services/CommonService.js";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import DateRangePicker from "vue2-daterange-picker";
import "vue-loading-overlay/dist/vue-loading.css";
import DatePicker from "vue2-datepicker";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import { GlobalGetLocation } from "../../helper/collection";
import { ModelListSelect, MultiSelect } from "vue-search-select";

export default {
  beforeMount() {
    this.getCurrentLastDate();
    this.$store.dispatch("common/setAllAgentColoaderList");
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    this.$store.dispatch(
      "common/setAllConsigneeList",
      JSON.stringify({
        itemCode: "ConsigneeList",
      })
    );
    this.$store.dispatch(
      "common/setAllConsignorList",
      JSON.stringify({
        itemCode: "ConsignorList",
      })
    );
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    this.$store.dispatch(
      "common/setAllPORList",
      JSON.stringify({
        itemCode: "PORList",
      })
    );
    this.$store.dispatch(
      "common/setAllPODList",
      JSON.stringify({
        itemCode: "PODList",
        type:'Normal',
        Territory:'',
      })
    );
    this.$store.dispatch(
      "common/setAllPOLList",
      JSON.stringify({
        itemCode: "POLList",
      })
    );
    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );
    this.$store.dispatch(
      "common/setAllLocationDetailsFinalList",
      JSON.stringify({
        itemCode: "LocationDetailsFinalList",
      })
    );
    if (globalPermissionStatus("BL Subscription List")) {
      this.$store.dispatch("setCurrentRoute", "/bl-subs-list");

      this.getBLSubsList();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export As Excel",
      All_BL_List_data: [],
      branch_items: [],
      Filter: {
        PODfilter: "",
        PORfilter: "",
        clientIdFilter: "",
        shippingLineFilter: "",
        LPlocationId: "",
        branchfilter: "",
        finalPlaceLocationId: "",
        ToFilter: "",
        Consignee: "",
        Consignor: "",
        agntColoaderId: "",
        assignmentNo: "",
        paymentStatus: "No",
        commonFilter: "",
      },

      reload: true,

      visible: true,
      selectDateFormat,
      openLeft: "right",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      totalRows: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      filter: null,
      sortDirection: "asc",
      docURL: URL_BASE_DOC,
      fields: [
        {
          key: "ffExportFclId",
          mainkey: "ffExportFclId",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "SysSOB",
          mainkey: "SysSOB",
          label: "SOB/Payment Status",
          sortable: true,

          sortDirection: "ASC",
        },
        {
          key: "BLCond",
          mainkey: "BLCond",
          label: "BL Details",
          sortable: true,

          sortDirection: "ASC",
        },
        // {
        //   key: "blStage",
        //   mainkey: "blStage",
        //   label: "BL Stage",
        //   sortable: true,

        //   sortDirection: "ASC",
        // },
        {
          key: "AssignementDetails",
          mainkey: "AssignementDetails",
          label: "Assignment Details",
          sortable: true,
          sortDirection: "ASC",
        },

        {
          key: "POR",
          mainkey: "POR",
          label: " Location Details",
          sortable: true,
          sortDirection: "ASC",
        },

        {
          key: "clientName",
          mainkey: "clientName",
          label: "Client/SLine",
          width: "500px",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "vessel_voyage",
          mainkey: "vessel_voyage",
          label: "Vessel",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "SubscriptionID",
          mainkey: "SubscriptionID",
          label: "Subscription",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "vgmSubmissionDate",
          mainkey: "vgmSubmissionDate",
          label: "VGM/SI",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "Payment_Status",
          mainkey: "Payment_Status",
          label: "O/F Payment Request Status",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "subStatus",
          mainkey: "subStatus",
          label: "Subscription Status",
          sortable: true,
          sortDirection: "ASC",
        },
        // ,
        // {
        //   key: "description",
        //   mainkey: "description",
        //   label: "CB Details",
        //   sortable: true,
        //   sortDirection: "ASC",
        // },
      ],
      isLoading: false,
      getCLientData: [],

      PaymentStatusList: [
        {
          inv: "Completed",
          int: "Yes",
        },
        {
          inv: "Pending",
          int: "No",
        },
      ],
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    ModelListSelect,
    MultiSelect,
    // Loading,
    CustomLoader,
    DateRangePicker,
  },
  computed: {
    clientList() {
      return this.getCLientData;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },

  methods: {
    PaymentSline(item) {
      console.log("item=>", item);

      this.$sessionsStorage.set("editExportFCLId", "");
      this.$sessionsStorage.set("editFFBookingId", "");
      this.$sessionsStorage.set("editSalesExId", "");
      if (
        item.allModuleId != "" &&
        item.allModuleId != undefined &&
        item.allModuleId != null
      ) {
        this.$sessionsStorage.set("editSalesExId", item.allModuleId);
      }
      if (
        item.ffBookingId != "" &&
        item.ffBookingId != undefined &&
        item.ffBookingId != null
      ) {
        this.$sessionsStorage.set("editFFBookingId", item.ffBookingId);
      }
      if (
        item.ffExportFclId != "" &&
        item.ffExportFclId != undefined &&
        item.ffExportFclId != null
      ) {
        this.$sessionsStorage.set("editExportFCLId", item.ffExportFclId);
      }

      if (
        item.ffExportFclId != "" &&
        item.ffExportFclId != undefined &&
        item.ffExportFclId != null &&
        item.ffBookingId != "" &&
        item.ffBookingId != undefined &&
        item.ffBookingId != null &&
        item.allModuleId != "" &&
        item.allModuleId != undefined &&
        item.allModuleId != null
      ) {
        this.$router.push({
          path: "/freightForward/ffSLinePaymentExportN_VP",
        });
      }
    },
    viewEditBLNonUs(item) {
      console.log("item=>", item);
      // return false;
      if (item.BLCond == "FCL BL") {
        this.$sessionsStorage.set("editfclBlId", "");
        this.$sessionsStorage.set("editExportFCLId", "");
        this.$sessionsStorage.set("editFFExecutionId", "");
        this.$sessionsStorage.set("editFFBookingId", "");
        this.$sessionsStorage.set("editfclBlId", item.fclBlId);
        this.$sessionsStorage.set("editExportFCLId", item.ffExportFclId);
        this.$sessionsStorage.set("editFFExecutionId", item.ffExecutionId);
        this.$sessionsStorage.set("editFFBookingId", item.ffBookingId);
      } else if (item.BLCond == "Consolidation BL") {
        // this.$sessionsStorage.set("editfclBlId", "");
        this.$sessionsStorage.set("editffFclConsoExportId", "");
        this.$sessionsStorage.set("editffConExecutionId", "");
        this.$sessionsStorage.set("editconFclBookingId", "");
        // this.$sessionsStorage.set("editfclBlId", item.fclBlId);
        this.$sessionsStorage.set("editffFclConsoExportId", item.ffExportFclId);
        this.$sessionsStorage.set("editffConExecutionId", item.ffExecutionId);
        this.$sessionsStorage.set("editconFclBookingId", item.ffBookingId);
      }

      let ContainerData = this.$store.getters.storeProceedContainer;

      console.log("ContainerData=>", ContainerData);
      // return false;

      if (
        (ContainerData == "" || ContainerData == null || ContainerData == undefined) &&
        !item.BlNumber
      ) {
      } else {
        if (item.blType == "LinerBL" || item.blType == "House BL") {
          this.$router.push({
            path: "/freightForward/fclBLofLanding",
          });
        } else {
          if (item.location == "NON_USA" && item.BLCond == "FCL BL") {
            this.$router.push({
              path: "/freightForward/BL-NonUS",
            });
          } else if (item.location == "USA" && item.BLCond == "FCL BL") {
            this.$router.push({
              path: "/freightForward/BL-US",
            });
          } else if (item.location != "USA" && item.BLCond == "Consolidation BL") {
            this.$router.push({
              path: "/ffExportCon/conBLNewNonUs",
            });
          } else if (item.location == "USA" && item.BLCond == "Consolidation BL") {
            this.$router.push({
              path: "/ffExportCon/conBLSlineUs",
            });
          }
        }
      }
    },
    trackingRed(SubscriptionID) {
      if (SubscriptionID && SubscriptionID != "") {
        this.$router.push({
          path: "/assignment/tracking",
          query: { trackingId: SubscriptionID },
        });
      }
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay1 = "";
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay1 = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + lastDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01

      this.startDate = firstDay1;
      this.dateRange = {
        startDate: firstDay1,
        endDate: lastDay,
      };
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    SearchFilter(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getBLSubsList();
      }, 1000);
    },
    SelectMultiBranch(branch_items, lastSelectItem) {
      this.branch_items = branch_items;
      console.log("branch_items=>", this.branch_items);

      this.Filter.branchfilter = "";
      this.Filter.branchNamefilter = "";
      if (this.branch_items) {
        this.branch_items.forEach((item_val) => {
          if (this.Filter.branchNamefilter) {
            this.Filter.branchNamefilter =
              this.Filter.branchNamefilter + "," + item_val.text;
          } else {
            this.Filter.branchNamefilter = item_val.text;
          }

          if (this.Filter.branchfilter) {
            this.Filter.branchfilter = this.Filter.branchfilter + "," + item_val.value;
          } else {
            this.Filter.branchfilter = item_val.value;
          }
        });
        console.log("Filter=>", this.Filter);
      }
      this.SearchFilter();
    },

    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    PrintNote(uploadCreditDebit, assign_job) {
      let key =
        "ASSIGNMENT_UPLOADS/" +
        assign_job.replaceAll("/", "_") +
        "/" +
        uploadCreditDebit;
      this.openSignedDocument(key);
    },

    getReports(id) {
      let agntColoaderId = "";
      if (this.Filter.ToFilter) {
        let agentArr = this.$store.getters["common/getAllAgentColoaderList"].filter(
          (x) => {
            if (this.Filter.ToFilter == x.agentName) {
              return x;
            }
          }
        );
        if (agentArr.length > 0) {
          this.Filter.agntColoaderId = agentArr[0].agntColoaderId;
        }
      }
      let payload = {
        itemCode: id,
        Filter: this.Filter,
        dateRange: this.dateRange,
        type: "Excell",
      };
      this.ExcelBtnName = "Downloading Please Wait .....";
      CommonService.getAllBLDash(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.excelName) {
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on All_BL_List Error: ", error);
        });
    },
    filterClear() {
      (this.Filter = {
        PODfilter: "",
        PORfilter: "",
        clientIdFilter: "",
        shippingLineFilter: "",
        LPlocationId: "",
        branchfilter: "",
        finalPlaceLocationId: "",
        ToFilter: "",
        Consignee: "",
        Consignor: "",
        assignmentNo: "",
        paymentStatus: "No",
        commonFilter: "",
      }),
        (this.dateSearch.fromDate = "");
      this.dateSearch.toDate = "";
      this.getBLSubsList();
    },
    onPageChange: function (event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      // this.getBLSubsList();
    },

    getBLSubsList() {
      this.isLoading = true;
      let agntColoaderId = "";
      if (this.Filter.ToFilter) {
        let agentArr = this.$store.getters["common/getAllAgentColoaderList"].filter(
          (x) => {
            if (this.Filter.ToFilter == x.agentName) {
              return x;
            }
          }
        );
        if (agentArr.length > 0) {
          this.Filter.agntColoaderId = agentArr[0].agntColoaderId;
        }
      }
      let payload = {
        itemCode: "getBLSubsList",
        Filter: this.Filter,
        dateRange: this.dateRange,
        type: "Normal",
      };

      CommonService.getAllBLDash(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.All_BL_List_data = data.Bldata;
            this.totalRows = data.Bldata.length;
          } else {
            this.All_BL_List_data = [];
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on All_BL_List Error: ", error);
        });
    },
  },
};
</script>
<style>
.md-theme-default.md-tabs > .md-tabs-navigation {
  background-color: #ffffff;
}
.md-theme-default.md-tabs > .md-tabs-navigation .md-tab-header {
  color: #6e6b79;
}
.md-theme-default.md-tabs > .md-tabs-navigation .md-tab-header.md-active,
.md-theme-default.md-tabs > .md-tabs-navigation .md-tab-header:focus {
  color: #6e6b79;
}
.md-theme-default.md-tabs > .md-tabs-navigation .md-tab-indicator {
  background-color: #002b48;
  height: 4px;
  border-radius: 10px;
}
.md-whiteframe {
  background: #fff;
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  -webkit-box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  border-radius: 0.423rem;
}
</style>



// WEBPACK FOOTER //
// blSubsListPending.vue?5f0b600f